export default __webpack_public_path__ + "static/media/choose-link-type.60b11354.png";